export default {
    button: {
        approve: 'Согласовать',
        reject: 'Отклонить',
        cancel: 'Аннулировать',
        annul: 'Аннулировать',
        send: 'Отправить',
        save: 'Сохранить',
        sameRequest: 'Новая похожая заявка на подбор'
    },
    alert: {
        success: 'Согласование отправлено успешно',
        error: 'Согласование не удалось'
    },
    approvalProject: {
        headers: {
            general:    'Основная информация',
            sender:     'Отправитель',
            timePassed: 'Отправлено',
            date:       'Дата отправки',
        },
        approval_type: 'Тип согласования'
    },
    sort: {
        title: 'Сортировка',
        position: {
            inc: 'По названию вакансии, от А до Я',
            dec: 'По названию вакансии, от Я до А'
        },
        peopleName: {
            inc: 'По фамилии, от А до Я',
            dec: 'По фамилии, от Я до А'
        },
        projectName: {
            inc: 'По названию вакансии, от А до Я',
            dec: 'По названию вакансии, от Я до А'
        },
        date: {
            inc: 'По дате получения, сначала старые',
            dec: 'По дате получения, сначала новые'
        },
        townName: {
            inc: 'По городу, от А до Я',
            dec: 'По городу, от Я до А'
        },
        senderName: {
            inc: 'По отправителю, от А до Я',
            dec: 'По отправителю, от Я до А'
        }
    },
};
